type Stat = { value: number; unit: string; signed: boolean };

// Число характеристики как в игре: «+15%», «−26%», «1,3 с». Знак — по `signed` и знаку числа
// (минус — типографский), дробная часть — на языке интерфейса, единица — как пришла.
export const formatStat = ({ value, unit, signed }: Stat, locale: string): string => {
  const number = new Intl.NumberFormat(locale, { maximumFractionDigits: 2 }).format(
    Math.abs(value),
  );
  const sign = value < 0 ? "−" : signed ? "+" : "";
  return `${sign}${number}${unit}`;
};
